import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,           // Clave API web de tu proyecto
  authDomain: "CloudComputing.firebaseapp.com",   // Normalmente: nombre-proyecto.firebaseapp.com
  projectId: "cloudcomputing-b38cb",     // ID del proyecto (no el número, sino el ID alfanumérico)
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);